import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";

// Images
import avatar1 from "assets/images/users/avatar-1.jpg";
import avatar2 from "assets/images/users/avatar-2.jpg";
import avatar3 from "assets/images/users/avatar-3.jpg";
import avatar4 from "assets/images/users/avatar-4.jpg";
import avatar5 from "assets/images/users/avatar-5.jpg";
import withRouter from "Common/withRouter";

import MecordLogo from "../../assets/images/mecord-logo.png";

const ParticlesAuth = ({ children }: any) => {
  return (
    <React.Fragment>
      <div className="auth-page-wrapper py-5 position-relative d-flex align-items-center justify-content-center min-vh-100">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11}>
              <Card className="mb-0">
                <Row className="g-0 align-items-center">
                 {/* Left side */}
<Col xxl={5} className="d-none d-xxl-block">
  <Card
    className="auth-card h-100 border-0 shadow-none mb-0"
    style={{
      background:
        "linear-gradient(160deg, #0f172a 0%, #020617 100%)",
      position: "relative",
      overflow: "hidden",
    }}
  >
    {/* Subtle Glow */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        background:
          "radial-gradient(circle at 30% 20%, rgba(56,189,248,0.12), transparent 55%)",
        pointerEvents: "none",
      }}
    />

    <Card.Body className="py-5 d-flex justify-content-between flex-column position-relative">
      
      {/* Center Visual */}
      <div className="auth-effect-main my-5 position-relative rounded-circle d-flex align-items-center justify-content-center mx-auto">
        <div className="effect-circle-1 position-relative mx-auto rounded-circle d-flex align-items-center justify-content-center">
          <div className="effect-circle-2 position-relative mx-auto rounded-circle d-flex align-items-center justify-content-center">
            <div className="effect-circle-3 mx-auto rounded-circle position-relative d-flex align-items-center justify-content-center">
              
              <div className="text-center px-4">
                <div
                  className="mx-auto mb-4"
                  style={{
                    maxWidth: "300px",
                    filter:
                      "drop-shadow(0 15px 30px rgba(0,0,0,0.6))",
                  }}
                >
                  <img
                    src={MecordLogo}
                    alt="Mecord Logo"
                    className="img-fluid"
                  />
                </div>

                <h4 className="text-white fw-semibold mb-2">
                  Mecord Dashboard
                </h4>
                <p className="text-white opacity-75 small">
                  Precision Instrumentation & Monitoring
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center">
        <p className="text-white opacity-50 mb-0 small">
          © {new Date().getFullYear()} Mecord Systems & Services
        </p>
      </div>

    </Card.Body>
  </Card>
</Col>

                  {/* Right side - login form */}
                  <Col
                    xs={12}
                    xxl={7}
                    className="d-flex justify-content-center"
                  >
                    {children}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
